import img1 from '../images/khoj-images/Logo.png'
import img2 from '../images/khoj-images/Logo2.png'
import img3 from '../images/khoj-images/Logo3.png'
import img4 from '../images/khoj-images/Logo4.png'
import img5 from '../images/khoj-images/Logo5.png'
import img6 from '../images/khoj-images/Logo6.png'



const dataPartner = [
    {
        id: 1,
        img: img1
    },
    {
        id: 2,
        img: img2
    },
    {
        id: 3,
        img: img3
    },
    {
        id: 4,
        img: img4
    },
    {
        id: 5,
        img: img5
    },
    {
        id: 6,
        img: img6
    },
    {
        id: 7,
        img: img1
    },
    {
        id: 8,
        img: img2
    },
    {
        id: 9,
        img: img3
    },
    {
        id: 10,
        img: img4
    },
]

export default dataPartner;